<div class="flex">
  <div class="flex__item flex__item--col">
    <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">
      <div class="chart-title">Rank as of {{ date() | date:'MMM yyyy' }}</div>
      <div class="chart-info">Showing {{ rankDisplay }} of {{ rankTotal }} institutions</div>
    </div>
    <div class="chart-container">
      <div #chart echarts [options]="chartOptions" [merge]="updateOptions" [initOpts]="initOptions" (chartInit)="onChartInit($event)" class="visual"></div>
    </div>
  </div>
</div>
